import { render } from "./ContactDev.vue?vue&type=template&id=bc8d51fc&scoped=true"
const script = {}

import "./ContactDev.vue?vue&type=style&index=0&id=bc8d51fc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc8d51fc"]])

export default __exports__